import React from 'react'
import { Mail, Phone, MapPin } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { companyInfo } from '../../data/company'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // 国际化的页脚链接
  const getFooterLinks = () => ({
    [t('footer.links.products')]: [
      { label: t('products.tag-conversion-device.name'), href: '/products', category: 'products' },
      { label: t('products.librarian-workstation-allinone.name'), href: '/products', category: 'products' },
      { label: t('footer.featuredProducts.rfidSecurity'), href: '/products', category: 'products' },
      { label: t('products.self-service-card-kiosk.name'), href: '/products', category: 'products' },
      { label: t('products.mini-24hour-cabinet.name'), href: '/products', category: 'products' }
    ],
    [t('footer.links.solutions')]: [
      { label: t('footer.solutions.aiInventory'), href: '/solutions', category: 'solutions' },
      { label: t('footer.solutions.k12Libraries'), href: '/solutions', category: 'solutions' },
      { label: t('footer.solutions.militaryProgram'), href: '/solutions', category: 'solutions' },
      { label: t('footer.solutions.corporateSpaces'), href: '/solutions', category: 'solutions' },
      { label: t('footer.solutions.publicLibraries'), href: '/solutions', category: 'solutions' }
    ],
    [t('footer.links.support')]: [
      { label: t('footer.support.publicLibraries'), href: '/cases', category: 'support' },
      { label: t('footer.support.k12Libraries'), href: '/cases', category: 'support' },
      { label: t('footer.support.academicLibraries'), href: '/cases', category: 'support' },
      { label: t('footer.support.corporateLibraries'), href: '/cases', category: 'support' },
      { label: t('footer.support.urbanReading'), href: '/cases', category: 'support' }
    ]
  })

  // 处理链接点击事件
  const handleLinkClick = (href: string) => {
    navigate(href)
  }

  return (
    <footer className="bg-secondary-900 text-white">
      {/* Main footer content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Company info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="/images/logo/1212.jpg" 
                  alt="MiJin Technology Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">{t('footer.company.name')}</h3>
                <p className="text-secondary-400">{t('hero.title')}</p>
              </div>
            </div>
            
            <p className="text-secondary-300 mb-6 leading-relaxed">
              {t('footer.company.description')}
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-primary-400" />
                <span className="text-secondary-300">{companyInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-primary-400" />
                <span className="text-secondary-300">{companyInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={18} className="text-primary-400" />
                <span className="text-secondary-300">{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Footer links */}
          {Object.entries(getFooterLinks()).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-lg font-semibold mb-4 text-white">{category}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <button
                      className="text-secondary-400 hover:text-primary-400 transition-colors duration-200 text-sm text-left"
                      onClick={() => handleLinkClick(link.href)}
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom footer */}
      <div className="border-t border-secondary-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-sm text-secondary-400 mb-4 md:mb-0">
              {t('footer.copyright')}
            </div>
            

            <div className="text-sm text-secondary-500">
              {t('footer.links.privacy')} • {t('footer.links.terms')}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 